const PG_UNIQUE_VIOLATION = '23505'

export class DeviceNameConflictError extends Error {}

export function isNameConflict(error: { code?: string }) {
  return error.code === PG_UNIQUE_VIOLATION
}

// reactivate_device raises this exact message when the device's status
// already moved on from 'inactive' by the time the request lands — e.g. two
// admin sessions open on the same device, or it was re-paired from the
// physical device in between. A stale-view race, not a bug, so it shouldn't
// be reported as an unexpected error.
export class DeviceStateConflictError extends Error {}

export function isDeviceStateConflict(error: { message?: string }) {
  return error.message === 'Device not found or not inactive'
}
